import { formatBooleanValue } from "../..";
import ReportingPeriodApplicantDocument, {
  IReportingPeriodApplicantDocument
} from "../../model/document/ReportingPeriodApplicantDocument";
import { IHttpService } from "../HttpService";

export interface IPortalReportingPeriodApplicantDocumentService {
  getReportingPeriodApplicantDocuments(
    reportingPeriodApplicantId: number
  ): Promise<IReportingPeriodApplicantDocument[]>;
}

const PortalReportingPeriodApplicantDocumentService = (
  httpService: IHttpService
): IPortalReportingPeriodApplicantDocumentService => {
  const _http: IHttpService = httpService;
  const _basePath: string = "/api/forms";
  const _documentsPath: string = "/documents";
  const _reportingPeriodApplicantPath: string = "/reporting-period-applicants";

  const reportingPeriodApplicantDocumentsListMapper = (
    json = []
  ): IReportingPeriodApplicantDocument[] => {
    return json.map((item: any) => {
      let reportingPeriodApplicantDocument =
        ReportingPeriodApplicantDocument(item);
      reportingPeriodApplicantDocument.valid = formatBooleanValue(item.valid);
      return reportingPeriodApplicantDocument;
    });
  };

  return {
    async getReportingPeriodApplicantDocuments(
      reportingPeriodApplicantId: number
    ) {
      const path = _http.buildPath(
        _basePath,
        _documentsPath,
        _reportingPeriodApplicantPath,
        reportingPeriodApplicantId.toString()
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return reportingPeriodApplicantDocumentsListMapper(responseJSON);
    }
  };
};

export default PortalReportingPeriodApplicantDocumentService;
